import React from 'react';

interface PageLoaderProps {
  message?: string;
  fullScreen?: boolean;
}

const PageLoader: React.FC<PageLoaderProps> = ({ message, fullScreen = false }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: fullScreen ? '100vh' : 320,
        gap: 20,
        background: fullScreen ? '#f8fafc' : 'transparent',
        animation: 'fadeIn 0.3s ease-out',
      }}
    >
      {/* Animated logo mark */}
      <div style={{ position: 'relative', width: 64, height: 64 }}>
        {/* Outer ring - spinning */}
        <div style={{
          position: 'absolute',
          inset: 0,
          borderRadius: '50%',
          border: '2px solid transparent',
          borderTopColor: '#22c55e',
          borderRightColor: '#22c55e',
          animation: 'pageLoaderSpin 0.9s linear infinite',
        }} />
        {/* Middle ring - spinning reverse */}
        <div style={{
          position: 'absolute',
          inset: 6,
          borderRadius: '50%',
          border: '2px solid transparent',
          borderBottomColor: '#16a34a',
          borderLeftColor: '#16a34a',
          animation: 'pageLoaderSpin 0.7s linear infinite reverse',
        }} />
        {/* Center icon */}
        <div style={{
          position: 'absolute',
          inset: 14,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #22c55e, #16a34a)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          animation: 'pageLoaderPulse 1.5s ease-in-out infinite',
          boxShadow: '0 4px 12px rgba(34,197,94,0.4)',
        }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
            <path d="M12 0C5.373 0 0 5.373 0 12c0 2.125.558 4.116 1.535 5.838L.057 23.197c-.07.283.006.581.198.792.148.162.354.25.565.25.077 0 .154-.011.229-.034l5.576-1.455A11.916 11.916 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818c-1.929 0-3.754-.525-5.317-1.441l-.38-.225-3.945 1.033 1.054-3.845-.247-.397A9.786 9.786 0 012.182 12C2.182 6.571 6.571 2.182 12 2.182S21.818 6.571 21.818 12 17.429 21.818 12 21.818z"/>
          </svg>
        </div>
      </div>

      {/* Loading dots */}
      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
        {[0, 1, 2].map(i => (
          <div
            key={i}
            style={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              background: '#22c55e',
              animation: `dotBlink 1.2s ease-in-out infinite`,
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </div>

      {/* Message */}
      {message && (
        <p style={{
          fontSize: '0.875rem',
          color: '#64748b',
          margin: 0,
          fontFamily: 'Inter, sans-serif',
          fontWeight: 500,
          animation: 'pageLoaderFade 1.5s ease-in-out infinite alternate',
          letterSpacing: '-0.01em',
        }}>
          {message}
        </p>
      )}
    </div>
  );
};

export default PageLoader;
